import { Component, Inject, OnInit, signal, WritableSignal } from '@angular/core';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentDetailsService } from '@app/dashboard/services/document-details.service';
import { AppealRecordDTO, CustomCaseTypeBasedDocType, DocumentTypeModel, IDType, PartyModelRequest, PartyRequest, PartyResponse } from '@app/dashboard/models/document-details.model';
import { ECaseCategory, ECourtId } from '@app/dashboard/models/constant';
import { ICaseType } from '@app/dashboard/models/case-status.model';
import { CommonModule, DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { ICourtUnitType } from '@app/dashboard/models/case-assignment.model';
import { MatTableModule } from '@angular/material/table';
import { MatRadioModule } from '@angular/material/radio';
import { IDRCaseDocument, modifyDocPayLoad } from '@app/dashboard/models/document-reception.model';
import { DialogMessageComponent } from '../../dialog-message/dialog-message.component';
import { ConfirmationDialogComponent } from '@app/confirmation-dialog/confirmation-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DocumentReceptionService } from '@app/dashboard/services/document-reception.service';
import { ILoginData } from '@app/lib/models/login.model';
import { DialogService } from '@app/lib/services/dialog.service';
import { CourtFormComponent } from "../court-form/court-form.component";
import { MatExpansionModule } from '@angular/material/expansion';
import { catchError, debounceTime, distinctUntilChanged, EMPTY, filter, finalize, map, Observable, of, switchMap, take, tap } from 'rxjs';

@Component({
  selector: 'app-document-details',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatTableModule,
    MatRadioModule,
    FormsModule,
    MatIconModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    CourtFormComponent,
    MatExpansionModule
  ],
  providers: [DatePipe],
  templateUrl: './document-detail-edit.component.html',
  styleUrls: ['./document-detail-edit.component.scss'],
})
export class DocumentDetailEditComponent implements OnInit {
  searchForm: FormGroup;
  searchForm2: FormGroup;
  caseCategories: { key: string; value: string }[] = [
    { key: 'FI', value: 'First Instance' },
    { key: 'A', value: 'Appeal' },
  ];
  caseTypes: ICaseType[] = [];
  documentTypes: CustomCaseTypeBasedDocType[] = [];
  caseStages: DocumentTypeModel[] = [];
  public caseCategoryEnum = ECaseCategory;
  public divisionList: WritableSignal<ICourtUnitType[]> = signal([]);
  public caseTypeList: WritableSignal<ICaseType[]> = signal([]);
  selectedCategory: string = '';
  selectedCaseType: number = 0;
  selectedDocumentType: number = 0;
  isLoading = false;
  isCaseTypeSelected = false;
  confirmDocuments = false;
  showCaseStage = false;
  selectedCopies: number = 1;
  petitionerDisplay: string = 'ABC';
  selectedFiledOnDate: string | null = null;
  petitionerSearchName: string = '';
  plaintiffSearchName: string = '';
  defendantSearchName: string = '';
  lowerCourt: string = '';
  oldSuitNumber: string = '';
  petitionerSelectedName: string = '';
  showTable: boolean = false;
  parties: PartyRequest[] = [];
  displayedColumns: string[] = [
    'prtType', //Party Type
    'partiesId', // Party ID
    'idStructureTypeName', // ID Name
    'idStructureTypeValue', // ID Number
    'partiesFullName', // Full Name
    'select',
  ];
  partiesNameText: string = '';
  partiesPlaintiffNameText: string = '';
  partiesDefendantNameText: string = '';
  selectedRow: any = null; // Tracks the currently selected row
  isTableVisible: boolean = false;
  showTableFor: 'filedBy' | 'plaintiff' | 'defendant' | null = null;
  addPartyForm: FormGroup;
  showAddPartyForm: boolean = false; // Tracks visibility of the Add Party form
  currentAddPartySection: 'filedBy' | 'plaintiff' | 'defendant' | null = null;
  partyTypeDropdownList = [
    { key: 'Person', value: 'PRS' },
    { key: 'Corporate', value: 'CRE' },
    { key: 'Govt', value: 'GOVT' },
  ];
  idTypeList: IDType[] = [];
  isIDTypeLoading = false;
  errorIDTypeMessage: string | null = null;
  isEditMode: boolean = false;
  isSupreme: boolean = false
  isCOA: boolean = false
  courtOfAppeals: any[] = [];
  trialCourts: any[] = [];
  courtOfAppealForm: FormGroup;
  trialCourtForm: FormGroup;
  public receivedCaseData: WritableSignal<IDRCaseDocument[]> = signal([]);

  constructor(private documentDetailsService: DocumentDetailsService,
    private documentRecpService: DocumentReceptionService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<DocumentDetailEditComponent>,
    private dialogService: DialogService,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: {
      data: IDRCaseDocument[],
      loginData: ILoginData,
      AppealDetails: AppealRecordDTO,
      onRefreshTasks?: () => void

    }
  ) {
    this.searchForm = new FormGroup({
      ...(
        !this.isCOA && !this.isSupreme
          ? { caseCategory: new FormControl('', Validators.required) }
          : { lowerCourt: new FormControl('', Validators.required) }
      ),
      courtDivision: new FormControl('', { nonNullable: true }),
      caseType: new FormControl('', Validators.required),
      docTypeId: new FormControl('', Validators.required),
    });
    this.searchForm2 = new FormGroup({
      caseStageId: new FormControl('', { nonNullable: true }),
      // selectedCopies: new FormControl(1),
      selectedCopies: new FormControl(1, [Validators.required, Validators.min(1)]),
      partiesNameText: new FormControl('', Validators.required),
      petitionerSearchName: new FormControl('', { nonNullable: true }),
      plaintiffSearchName: new FormControl('', { nonNullable: true }),
      defendantSearchName: new FormControl('', { nonNullable: true }),
      partiesPlaintiffNameText: new FormControl('', Validators.required),
      partiesDefendantNameText: new FormControl('', Validators.required),
      filedOn: new FormControl(null, Validators.required),
      comments: new FormControl(''),
      oldSuitNumber: new FormControl(''),
      lowerCourt: new FormControl(''),
      suitNumber: new FormControl('')
    });

    this.addPartyForm = new FormGroup({
      partyType: new FormControl('PRS', Validators.required),
      partyTypeDropdown: new FormControl(''),
      partyName: new FormControl(''),
      partyGroupName: new FormControl(''),
      partyAdditionalInfo: new FormControl(''),
      partySurname: new FormControl(''),
      idType: new FormControl('', Validators.required),
      idNumber: new FormControl('', Validators.required),
    });

    this.courtOfAppealForm = new FormGroup({
      courtOfAppeal: new FormControl(null, Validators.required),
      divisionAtCourtOfAppeal: new FormControl('', Validators.required),
      courtOfAppealCaseNo: new FormControl('', Validators.required),
      panelOfJustices: new FormControl([], Validators.required),
      appealCourtJudgmentDate: new FormControl(null, Validators.required),
      noticeOfAppealFiledDate: new FormControl(null, Validators.required),
      transmissionOfRecordDate: new FormControl(null, Validators.required),
      serviceOfAppealRecordDate: new FormControl(null, Validators.required),
      supplementaryRecordFiled: new FormControl(false),
      supplementaryRecordDate: new FormControl(null)
    });

    this.trialCourtForm = new FormGroup({
      trialCourt: new FormControl(null, Validators.required),
      trialCourtDivision: new FormControl(null, Validators.required),
      trialJudge: new FormControl([], Validators.required),
      trialCourtJudgementDate: new FormControl(null, Validators.required),
      serviceOfAppellantsDate: new FormControl(null, Validators.required)
    });

  }

  ngOnInit(): void {
    // Check if data is received from the parent
    this.getCourtNameData();
    const receivedData = this.data.data
    //console.log((receivedData.length))

    if (receivedData.length) {
      //console.log('Received data from parent:', receivedData);
      this.isEditMode = true;
      this.receivedCaseData.set(receivedData);


      // Populate the first form (searchForm)
      if (receivedData[0].caseCategory || receivedData[0].courtUnitName || receivedData[0].ctpShortName || receivedData[0].docTypeId) {
        this.searchForm.patchValue({
          ...(!this.isCOA && !this.isSupreme ? {
            caseCategory: this.caseCategories.find(
              (category) => category.key === receivedData[0].caseCategory
            )?.key || ''
          } : { lowerCourt: receivedData[0].appealCourtName || '', }),
          courtDivision: receivedData[0].courtUnitName || '',
          caseType: receivedData[0].ctpShortName || '',
          docTypeId: receivedData[0].docTypeId || '',
        });

        // Automatically fetch document types if the necessary fields are prepopulated
        this.selectedCategory = this.caseCategories.find(
          (category) => category.key === receivedData[0].caseCategory
        )?.key || '';
        this.selectedCaseType = receivedData[0].ctpId || 0;
        this.selectedDocumentType = receivedData[0].docTypeId || 0;


        this.searchForm2.patchValue({
          partiesNameText: receivedData[0].partiesByPrtIdReallyIssuedByName || '',
          petitionerSearchName: receivedData[0].partiesByPrtIdReallyIssuedBy || '',
          plaintiffSearchName: receivedData[0].partiesByPrtIdIssuedBy || '',
          defendantSearchName: receivedData[0].partyIdCharging || '',
          partiesPlaintiffNameText: receivedData[0].partiesByPrtIdIssuedByName || '',
          partiesDefendantNameText: receivedData[0].partyIdChargingName || '',
          filedOn: receivedData[0].dateReceived || null,
          comments: receivedData[0].comments || null,
          selectedCopies: receivedData[0].numberOfCopies || 0,
          lowerCourt: receivedData[0].appealCourtName || '',
          oldSuitNumber: receivedData[0].oldCaseNumber || '',
          caseStageId: receivedData[0].cptShortName || '',
          suitNumber: receivedData[0].suitNumber || ''

        });



        // Automatically fetch case stages if relevant data is prepopulated

      }

      // Enable the next step if documents are confirmed
      if (receivedData) {
        this.confirmDocuments = true;
        this.showCaseStage = true;
      }
    } else {
      this.isEditMode = false;


      // Fetch initial data for dropdowns
      this.documentDetailsService.getDivisions().subscribe({
        next: (res) => this.divisionList.set(res.data || res.success || []),
      });
      this.documentDetailsService.getCaseTypes().subscribe({
        next: (res) => this.caseTypeList.set(res.data || []),
      });

      this.addPartyForm.get('partyType')?.valueChanges.subscribe((partyType) => {

      });
    }
    if (this.data.AppealDetails) {
      const additionalDataObj = this.data.AppealDetails;
      this.courtOfAppealForm.patchValue({
        courtOfAppeal: additionalDataObj.courtOfAppealId && additionalDataObj.courtOfAppealName
          ? { id: additionalDataObj.courtOfAppealId, name: additionalDataObj.courtOfAppealName }
          : null,
        divisionAtCourtOfAppeal: additionalDataObj.appealDivisionId && additionalDataObj.appealDivisionName
          ? { id: additionalDataObj.appealDivisionId, name: additionalDataObj.appealDivisionName }
          : null,
        courtOfAppealCaseNo: additionalDataObj.appealCaseNo || '',
        panelOfJustices: additionalDataObj.coaJustices || '',
        appealCourtJudgmentDate: additionalDataObj.appealJudgmentDate ? this.formatDateFromMillis(additionalDataObj.appealJudgmentDate) : null,
        noticeOfAppealFiledDate: additionalDataObj.noticeFiledDate ? this.formatDateFromMillis(additionalDataObj.noticeFiledDate) : null,
        transmissionOfRecordDate: additionalDataObj.transmissionDate ? this.formatDateFromMillis(additionalDataObj.transmissionDate) : null,
        serviceOfAppealRecordDate: additionalDataObj.appealServiceDate ? this.formatDateFromMillis(additionalDataObj.appealServiceDate) : null,
        supplementaryRecordFiled: additionalDataObj.supplementaryFiled || '',
        supplementaryRecordDate: additionalDataObj.supplementaryFiledDate ? this.formatDateFromMillis(additionalDataObj.supplementaryFiledDate) : null,
      });
      this.trialCourtForm.patchValue({
        trialCourt: additionalDataObj.trialCourtId && additionalDataObj.trialCourtName
          ? { id: additionalDataObj.trialCourtId, name: additionalDataObj.trialCourtName }
          : null,
        trialCourtDivision: additionalDataObj.trialCourtDivisionId && additionalDataObj.trialCourtDivisionName
          ? { id: additionalDataObj.trialCourtDivisionId, name: additionalDataObj.trialCourtDivisionName }
          : null,
        trialJudge: additionalDataObj.trailJudges || '',
        trialCourtJudgementDate: this.formatDateFromMillis(additionalDataObj.trialJudgmentDate) || '',
        serviceOfAppellantsDate: this.formatDateFromMillis(additionalDataObj.appellantServiceDate) || '',
      });
    }
    const notice = this.courtOfAppealForm.get('noticeOfAppealFiledDate');
    const transmission = this.courtOfAppealForm.get('transmissionOfRecordDate');
    const service = this.courtOfAppealForm.get('serviceOfAppealRecordDate');
    if (this.isSupreme && receivedData[0].ctpShortName === 'ML') {
      notice?.clearValidators();
      transmission?.clearValidators();
      service?.clearValidators();

      notice?.updateValueAndValidity();
      transmission?.updateValueAndValidity();
      service?.updateValueAndValidity();
    } else {
      notice?.setValidators([Validators.required]);
      transmission?.setValidators([Validators.required]);
      service?.setValidators([Validators.required]);

      notice?.updateValueAndValidity();
      transmission?.updateValueAndValidity();
      service?.updateValueAndValidity();
    }
  }
  formatDateFromMillis(milliseconds: any): Date {
    const date = new Date(milliseconds);
    return date;
  }

  saveNext() {
    if (this.confirmDocuments) {
      this.dialogService.openDialog1({
        data: {
          title: "Information",
          message: 'Saved Successfully!',
          icon: 'info', // ✅ Default icon if not provided
        }, disableClose: true,           // Prevents closing on outside click or ESC
        hasBackdrop: true,            // Shows backdrop to block interaction
        backdropClass: 'dialog-backdrop', // Optional: custom styling
      });

      this.dialogRef.close(true);
    } else {
      this.dialogService.openDialog1({
        data: {
          title: "Information",
          message: 'Please confirm the mandatory documents.',
          icon: 'info', // ✅ Default icon if not provided
        }, disableClose: true,           // Prevents closing on outside click or ESC
        hasBackdrop: true,            // Shows backdrop to block interaction
        backdropClass: 'dialog-backdrop', // Optional: custom styling
      });
    }
  }

  close() {
    this.dialogRef.close(false);
  }





  save(): void {
    if (this.data.data[0].numberOfCopies == this.searchForm2.get('selectedCopies')?.value && this.data.data[0].comments == this.searchForm2.get('comments')?.value && !this.hasCourtDataChanged()) {
      this.dialogService.openDialog1({
        data: {
          title: "Information",
          message: "No Modification done",
          icon: 'info', // ✅ Default icon if not provided
        }, disableClose: true,           // Prevents closing on outside click or ESC
        hasBackdrop: true,            // Shows backdrop to block interaction
        backdropClass: 'dialog-backdrop', // Optional: custom styling
      });
    }
    else {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, { // Set dialog width
        data: {
          title: 'Confirm Action',
          message: 'Are you sure you want to proceed?',

        }, disableClose: true,           // Prevents closing on outside click or ESC
        hasBackdrop: true,            // Shows backdrop to block interaction
        backdropClass: 'dialog-backdrop', // Optional: custom styling
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.saveEdit();
        } else {
          //console.log('Cancelled!');
          // Handle the cancellation
        }
      });
    }

  }

  private isFormChanged(form: FormGroup, originalData: any, mapping: Record<string, string>): boolean {
    return Object.keys(mapping).some(key => {
      const formValue = form.get(key)?.value;
      const originalValue = originalData[mapping[key]];

      // Handle object comparisons (like dropdown selections)
      if (formValue && typeof formValue === 'object' && 'id' in formValue) {
        return formValue.id !== originalValue;
      }

      // Handle arrays (like trialJudge / panelOfJustices)
      if (Array.isArray(formValue)) {
        return JSON.stringify(formValue) !== JSON.stringify(originalValue);
      }

      // Handle normal primitive values
      return formValue !== originalValue;
    });
  }



  saveEdit(): void {
    this.isLoading = true;

    const reqbody: modifyDocPayLoad = {
      courtUnitName: this.data.data[0].courtUnitName,
      courtUnitId: this.data.data[0].courtUnitId.toString(),
      appealCourtName: this.data.data[0].appealCourtName?.toString() || '',
      appealCourtId: this.data.data[0].appealCourtId?.toString() || '',
      ctpShortName: this.data.data[0].ctpShortName,
      ctpId: this.data.data[0].ctpId?.toString() || '',
      docTypename: this.data.data[0].docTypename,
      docTypeId: this.data.data[0].docTypeId.toString(),
      cptShortName: this.data.data[0].cptShortName,
      cptId: this.data.data[0].cptId?.toString() || '',
      courtCaseNumber: this.data.data[0].courtCaseNumber,
      casePhaseId: this.data.data[0].casePhaseId?.toString() || '',
      docId: this.data.data[0].docId,
      casePhaseCasId: this.data.data[0].casePhaseCasId?.toString() || '',
      partiesByPrtIdReallyIssuedBy: this.data.data[0].partiesByPrtIdReallyIssuedBy,
      partiesByPrtIdReallyIssuedByName: this.data.data[0].partiesByPrtIdReallyIssuedByName,
      filedByPartyIdPartyType: '',
      partiesByPrtIdIssuedBy: this.data.data[0].partiesByPrtIdIssuedBy,
      partiesByPrtIdIssuedByName: this.data.data[0].partiesByPrtIdIssuedByName,
      appellentPartyIdPartyType: '',
      appGroupGovtFlag: '',
      partyIdCharging: this.data.data[0].partyIdCharging,
      partyIdChargingName: this.data.data[0].partyIdChargingName,
      respondentFieldIdPartyType: '',
      respGroupGovtFlag: '',
      comments: this.searchForm2.get('comments')?.value,
      isTrackingNumber: '',
      restrictionName: '',
      restrictionId: '',
      receiptTypeName: 'Hand',
      receiptTypeId: '1',
      numberOfCopies: this.searchForm2.get('selectedCopies')?.value,
      dateReceived: this.data.data[0].dateReceived?.toString() || '',
      dateMailed: this.data.data[0].dateMailed?.toString() || '',
      oldCaseNumber: this.data.data[0].oldCaseNumber,
      suitNumber: this.data.data[0].suitNumber,
      triggeredTaskId: this.data.data[0].triggeredTaskId?.toString() || '',
      triggeredTaskDetails: this.data.data[0].triggeredTaskDetails?.toString() || '',
      cutId: '',
      hearingCourtUnitName: this.data.data[0].hearingCourtUnitName?.toString() || '',
      hearingCourtUnitId: this.data.data[0].hearingCourtUnitId?.toString() || '',
      transType: "U",
      documentsGridAddMessage: this.data.data[0].documentsGridAddMessage?.toString() || '',
      uploadDateReceived: this.data.data[0].uploadDateReceived?.toString() || '',
      courtType: this.data.data[0].courtType?.toString() || '',
      caseCategory: this.data.data[0].caseCategory,
      courtUnitShortName: this.data.data[0].courtUnitShortName,
      appealRecordDto: this.isSupreme && this.hasCourtDataChanged() ? {
        courtOfAppealName: this.courtOfAppealForm.get('courtOfAppeal')?.value.name || '',
        courtOfAppealId: this.courtOfAppealForm.get('courtOfAppeal')?.value.id ?? null,
        appealDivisionName: this.courtOfAppealForm.get('divisionAtCourtOfAppeal')?.value.name || '',
        appealDivisionId: this.courtOfAppealForm.get('divisionAtCourtOfAppeal')?.value.id ?? null,
        appealCaseNo: this.courtOfAppealForm.get('courtOfAppealCaseNo')?.value || '',
        coaJustices: this.courtOfAppealForm.get('panelOfJustices')?.value || [],
        appealJudgmentDate: this.datePipe.transform(this.courtOfAppealForm.get('appealCourtJudgmentDate')?.value, 'yyyy-MM-dd') || '',
        noticeFiledDate: this.datePipe.transform(this.courtOfAppealForm.get('noticeOfAppealFiledDate')?.value, 'yyyy-MM-dd') || '',
        transmissionDate: this.datePipe.transform(this.courtOfAppealForm.get('transmissionOfRecordDate')?.value, 'yyyy-MM-dd') || '',
        appealServiceDate: this.datePipe.transform(this.courtOfAppealForm.get('serviceOfAppealRecordDate')?.value, 'yyyy-MM-dd') || '',
        supplementaryFiled: this.courtOfAppealForm.get('supplementaryRecordFiled')?.value ?? false,
        supplementaryFiledDate: this.datePipe.transform(this.courtOfAppealForm.get('supplementaryRecordDate')?.value, 'yyyy-MM-dd') || '',

        trialCourtId: this.trialCourtForm.get('trialCourt')?.value.id ?? null,
        trialCourtName: this.trialCourtForm.get('trialCourt')?.value.name || '',
        trialCourtDivisionId: this.trialCourtForm.get('trialCourtDivision')?.value.id ?? null,
        trialCourtDivisionName: this.trialCourtForm.get('trialCourtDivision')?.value.name || '',
        trailJudges: this.trialCourtForm.get('trialJudge')?.value || [],
        trialJudgmentDate: this.datePipe.transform(this.trialCourtForm.get('trialCourtJudgementDate')?.value, 'yyyy-MM-dd') || '',
        appellantServiceDate: this.datePipe.transform(this.trialCourtForm.get('serviceOfAppellantsDate')?.value, 'yyyy-MM-dd') || '',

        suitReferenceKey: '',
        casereqId: '',
        caseId: '',
        createdByApp: '',
        createdAt: '',
      } : null
    };

    //console.log('test', reqbody);

    // Added catchError and finalize blocks to safely close loading states and refresh tasks
    this.documentRecpService.updateDocParty(reqbody).pipe(
      catchError((error) => {
        console.error('Error updating document party data:', error);
        this.dialogService.openDialog1({
          data: { title: 'Error', message: 'Failed to update the document. Please try again.', icon: 'error' },
          disableClose: true,
          hasBackdrop: true,
          backdropClass: 'dialog-backdrop',
        });
        return EMPTY;
      }),
      finalize(() => {
        this.isLoading = false;
        // Triggers the direct functional callback passed through your overlay config data layer
        if (this.data && this.data.onRefreshTasks) {
          this.data.onRefreshTasks();
        }
      })
    ).subscribe({
      next: (response) => {
        //console.log('Person service response:', response);
        this.dialogRef.close(response);
      }
    });
  }

  // Helpers (inside the class)
  private toMillis(v: any): number | null {
    if (v == null || v === '') return null;
    const d = v instanceof Date ? v : new Date(v);
    return isNaN(d.getTime()) ? null : d.getTime();
  }

  private idsChanged(arr1: any[], arr2: any[]): boolean {
    const toIds = (a: any[]) =>
      (a || [])
        .map(x => (x && typeof x === 'object' ? (x.id ?? x) : x))
        .filter(x => x != null)
        .sort();
    const A = toIds(arr1);
    const B = toIds(arr2);

    // debug
    console.debug('[idsChanged] A(ids)=', A, ' B(ids)=', B);

    if (A.length !== B.length) return true;
    for (let i = 0; i < A.length; i++) if (A[i] !== B[i]) return true;
    return false;
  }

  // private dbg(label: string, left: any, right: any, changed: boolean) {
  //   console.debug(`🔍 ${label}:`, { left, right, changed });
  // }

  // Main checker (with per-line debug)
  private hasCourtDataChanged(): boolean {
    const ad = this.data.AppealDetails || {};

    // ----- Court of Appeal block -----
    const coaIdLeft = ad.courtOfAppealId ?? null;
    const coaIdRight = this.courtOfAppealForm.get('courtOfAppeal')?.value?.id ?? null;
    const cmpCoaId = coaIdLeft !== coaIdRight;
    //this.dbg('CoA: courtOfAppealId', coaIdLeft, coaIdRight, cmpCoaId);

    const divIdLeft = ad.appealDivisionId ?? null;
    const divIdRight = this.courtOfAppealForm.get('divisionAtCourtOfAppeal')?.value?.id ?? null;
    const cmpDivId = divIdLeft !== divIdRight;
    //this.dbg('CoA: appealDivisionId', divIdLeft, divIdRight, cmpDivId);

    // NOTE: control name fixed to 'supplementaryRecordFiled'
    const suppFlagLeft = !!ad.supplementaryFiled;
    const suppFlagRight = !!(this.courtOfAppealForm.get('supplementaryRecordFiled')?.value ?? false);
    const cmpSuppFlag = suppFlagLeft !== suppFlagRight;
    // this.dbg('CoA: supplementaryFiled(flag)', suppFlagLeft, suppFlagRight, cmpSuppFlag);

    const suppDateLeft = ad.supplementaryFiledDate === null ? 0 : this.toMillis(ad.supplementaryFiledDate);
    const suppDateRight = this.toMillis(this.courtOfAppealForm.get('supplementaryRecordDate')?.value);
    const cmpSuppDate = suppDateLeft !== suppDateRight;
    // this.dbg('CoA: supplementaryFiledDate(ms)', suppDateLeft, suppDateRight, cmpSuppDate);

    const jdgLeft = this.toMillis(ad.appealJudgmentDate);
    const jdgRight = this.toMillis(this.courtOfAppealForm.get('appealCourtJudgmentDate')?.value);
    const cmpJdg = jdgLeft !== jdgRight;
    // this.dbg('CoA: appealJudgmentDate(ms)', jdgLeft, jdgRight, cmpJdg);

    const noticeLeft = this.toMillis(ad.noticeFiledDate);
    const noticeRight = this.toMillis(this.courtOfAppealForm.get('noticeOfAppealFiledDate')?.value);
    const cmpNotice = noticeLeft !== noticeRight;
    // this.dbg('CoA: noticeFiledDate(ms)', noticeLeft, noticeRight, cmpNotice);

    const transLeft = this.toMillis(ad.transmissionDate);
    const transRight = this.toMillis(this.courtOfAppealForm.get('transmissionOfRecordDate')?.value);
    const cmpTrans = transLeft !== transRight;
    // this.dbg('CoA: transmissionDate(ms)', transLeft, transRight, cmpTrans);

    const servLeft = this.toMillis(ad.appealServiceDate);
    const servRight = this.toMillis(this.courtOfAppealForm.get('serviceOfAppealRecordDate')?.value);
    const cmpServ = servLeft !== servRight;
    // this.dbg('CoA: appealServiceDate(ms)', servLeft, servRight, cmpServ);

    const coaJudgesLeft = ad.coaJustices;
    const coaJudgesRight = this.courtOfAppealForm.get('panelOfJustices')?.value;
    const cmpCoaJudges = this.idsChanged(coaJudgesLeft, coaJudgesRight);
    // this.dbg('CoA: panelOfJustices(ids)', coaJudgesLeft, coaJudgesRight, cmpCoaJudges);

    const courtOfAppealChanged =
      cmpCoaId || cmpDivId || cmpSuppFlag || cmpSuppDate || cmpJdg || cmpNotice || cmpTrans || cmpServ || cmpCoaJudges;

    // ----- Trial Court block -----
    const tcIdLeft = ad.trialCourtId ?? null;
    const tcIdRight = this.trialCourtForm.get('trialCourt')?.value?.id ?? null;
    const cmpTcId = tcIdLeft !== tcIdRight;
    // this.dbg('Trial: trialCourtId', tcIdLeft, tcIdRight, cmpTcId);

    const tdivIdLeft = ad.trialCourtDivisionId ?? null;
    const tdivIdRight = this.trialCourtForm.get('trialCourtDivision')?.value?.id ?? null;
    const cmpTDivId = tdivIdLeft !== tdivIdRight;
    // this.dbg('Trial: trialCourtDivisionId', tdivIdLeft, tdivIdRight, cmpTDivId);

    const tJudgesLeft = ad.trailJudges;
    const tJudgesRight = this.trialCourtForm.get('trialJudge')?.value;
    const cmpTJudges = this.idsChanged(tJudgesLeft, tJudgesRight);
    // this.dbg('Trial: trialJudge(ids)', tJudgesLeft, tJudgesRight, cmpTJudges);

    // NOTE: control name is 'trialCourtJudgementDate' (with 'e')
    const tJdgLeft = this.toMillis(ad.trialJudgmentDate);
    const tJdgRight = this.toMillis(this.trialCourtForm.get('trialCourtJudgementDate')?.value);
    const cmpTJudg = tJdgLeft !== tJdgRight;
    //this.dbg('Trial: trialJudgmentDate(ms)', tJdgLeft, tJdgRight, cmpTJudg);

    const tServLeft = this.toMillis(ad.appellantServiceDate);
    const tServRight = this.toMillis(this.trialCourtForm.get('serviceOfAppellantsDate')?.value);
    const cmpTServ = tServLeft !== tServRight;
    //this.dbg('Trial: appellantServiceDate(ms)', tServLeft, tServRight, cmpTServ);

    const trialCourtChanged = cmpTcId || cmpTDivId || cmpTJudges || cmpTJudg || cmpTServ;

    console.debug('==> courtOfAppealChanged:', courtOfAppealChanged, ' trialCourtChanged:', trialCourtChanged);

    return courtOfAppealChanged || trialCourtChanged;
  }


  // Close the table
  closeTable(): void {
    this.isTableVisible = false; // Hide the table
    this.currentAddPartySection = null;
    this.selectedRow = null; // Clear selection
    this.showTableFor = null;
    //console.log('Table closed.');
  }
  getCourtNameData(): ILoginData | null {
    try {
      const userData = localStorage.getItem('userData') as string;
      const userData2 = userData ? JSON.parse(userData) : null;


      //supreme court
      if (userData2.courtId && userData2.courtId === ECourtId.SC_ID) {
        this.isSupreme = true;
      } else if (userData2.courtId && userData2.courtId === ECourtId.COA_ID) {
        this.isCOA = true;
      }
      //console.log(`userData2 :: ${userData2}`)
      // return userData ? JSON.parse(userData) : null;
      return userData2;
    } catch (err) {
      return null
    }
  }

}